import type { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";

export type OperatorBottomNavigationItem = {
  key: string;
  label: string;
  to: string;
  icon: ReactNode;
  match?: "exact" | "prefix";
  activePrefixes?: string[];
};

type OperatorBottomNavigationProps = {
  items: OperatorBottomNavigationItem[];
  ariaLabel?: string;
};

function isItemActive(item: OperatorBottomNavigationItem, pathname: string): boolean {
  if (item.match === "exact") {
    return pathname === item.to;
  }

  const prefixes = item.activePrefixes?.length ? item.activePrefixes : [item.to];
  return prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function OperatorBottomNavigation({
  items,
  ariaLabel = "講師・管理者向けページナビゲーション"
}: OperatorBottomNavigationProps) {
  const location = useLocation();

  if (items.length === 0) {
    return null;
  }

  const isScrollable = items.length > 5;

  return (
    <nav className="family-bottom-nav" aria-label={ariaLabel}>
      <div
        className={`family-bottom-nav__list${isScrollable ? " family-bottom-nav__list--scrollable" : ""}`}
        {...(!isScrollable ? { style: { gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` } } : {})}
      >
        {items.map((item) => (
          <Link
            key={item.key}
            to={item.to}
            className="family-bottom-nav__item"
            aria-current={isItemActive(item, location.pathname) ? "page" : undefined}
          >
            <span className="family-bottom-nav__icon-wrap">
              {item.icon}
            </span>
            <span className="family-bottom-nav__label">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
